/* eslint-disable */

import { FileInfo, UPLOAD_FORM_FIELD_KEY } from 'components/modules/CustomForm';
import { CheckboxFormField, DropdownFormField, InputFormField, RadioFormField } from 'models';
import { FormErrorMessages } from '../../constants/formErrorMessage';

// const emailRegex =
//   /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const emailRegex = /^(?!.*\.\.)(?![_.])[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
const telephoneRegexCharacters = /^\+?[ 1-9][ 0-9]{5,15}$/;
// const telephoneRegexLength = /^[ 0-9+/-]{5,15}$/;
// const textRegex = /^(?!\s*$)(?!\s)(?!.*\s$)[a-zA-Z0-9><?@+'`~^%&\*\[\]\{\}.!#|\\\"$';,:;=/\(\),\-\w\s]+$/;

const textRegex = /^(?!\s*$)[a-zA-Z0-9><?@+'`~^%&\*\[\]\{\}.!#|\\\"$';,:;=/\(\),\-\w\s+]*/;
const alphanumericRegex = /^[a-z0-9 ]+$/i;
// const textRegexLength = /^[a-zA-Z ]{1,150}$/
// const nameRegex = /^(?!\s*$)[a-zA-Z><?@+'`~^%&\*\[\]\{\}.!#|\\\"$';,:;=/\(\),\-\w\s+]*$/;
// const fileRegex = /^[0-9a-zA-Z_\-. ]+$/
const nameRegex = /^(?!\s*$)[\p{Letter}\s\-!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/u;

export const validatCheckField = (field: RadioFormField | CheckboxFormField | DropdownFormField) => (value) => {
  let error;
  if (field.elements.required.value[0].codename === 'yes' && !value) {
    error = `${field.elements.name.value} is required`;
  }
  return error;
};
const alphanumericList = [
  'Company Registration Number (CVR)',
  // 'Street Address',
  'ZIP / Postal code',
  'Amount applied for',
  // 'Information on any co-funding',
];
export const validateInputField = (field: InputFormField) => (value) => {
  let error;

  if (field.elements.required.value[0].codename === 'yes' && !value) {
    error = FormErrorMessages[field.elements.name.value];
  }
  if (value && field.elements.type.value[0].codename === 'number' && isNaN(+value)) {
    error = `${field.elements.name.value} is not a number`;
  }
  if (value && field.elements.label.value === 'Email' && !emailRegex.test(value)) {
    error = `Please enter a valid ${field.elements.name.value} address`;
  }
  if (value && alphanumericList.includes(field.elements.label.value) && !alphanumericRegex.test(value)) {
    error = `${field.elements.name.value} is not valid`;
  }
  if (
    value &&
    field.elements.type.value[0].codename === 'text' &&
    !alphanumericList.includes(field.elements.label.value) &&
    field.elements.label.value != 'First Name' &&
    field.elements.label.value != 'Surname' &&
    !textRegex.test(value)
  ) {
    error = `${field.elements.name.value} should not be empty, numbers or special characters`;
  }
  if (value && field.elements.type.value[0].codename === 'textarea' && !textRegex.test(value)) {
    error = `${field.elements.name.value} should not be empty, numbers or special characters`;
  }

  if (
    value &&
    field.elements.type.value[0].codename === 'textarea' &&
    textRegex.test(value) &&
    field.elements.allowedCharacters.value != null &&
    value.length > field.elements.allowedCharacters.value
  ) {
    error = `${field.elements.name.value} should not be more than ${field.elements.allowedCharacters.value} characters`;
  }

  if (
    value &&
    field.elements.type.value[0].codename === 'text' &&
    !alphanumericList.includes(field.elements.label.value) &&
    textRegex.test(value) &&
    field.elements.allowedCharacters.value != null &&
    value.length > field.elements.allowedCharacters.value
  ) {
    error = `${field.elements.name.value} should not be more than ${field.elements.allowedCharacters.value} characters`;
  }
  if (
    value &&
    alphanumericList.includes(field.elements.label.value) &&
    alphanumericRegex.test(value) &&
    field.elements.allowedCharacters.value !== null &&
    value.length > field.elements.allowedCharacters.value
  ) {
    error = `${field.elements.name.value} should not be more than ${field.elements.allowedCharacters.value} characters`;
  }
  if (value && field.elements.label.value == 'First Name' && !nameRegex.test(value)) {
    error = `${field.elements.name.value} is not valid`;
  }
  if (value && field.elements.label.value == 'Surname' && !nameRegex.test(value)) {
    error = `${field.elements.name.value} is not valid`;
  }

  if (value && field.elements.label.value == 'Amount applied for' && isNaN(+value)) {
    error = `Please enter valid amount`;
  }
  if (value && alphanumericList.includes(field.elements.label.value) && !alphanumericRegex.test(value)) {
    error = `${field.elements.name.value} is not in valid format`;
  }
  if (value && field.elements.type.value[0].codename === 'telephone') {
    if (!telephoneRegexCharacters.test(value)) {
      error = ` Please enter a valid ${field.elements.name.value}`;
    }
    //  else if (telephoneRegexCharacters.test(value) &&( value.length < 5 || value.length > 15) ) {
    //   error = `${field.elements.name.value} must have 5 - 15 characters.`;
    // }
  }

  return error;
};

export const isFileInValid = (files: FileInfo[]) => {
  return (
    !files.some((file) => file.file.type.includes('pdf')) &&
    !files.some((file) => file.file.type.includes('text')) &&
    !files.some((file) => file.file.type.includes('jpeg')) &&
    !files.some((file) => file.file.type.includes('jpg')) &&
    !files.some((file) => file.file.type.includes('png')) &&
    !files.some((file) => file.file.type.includes('rtf')) &&
    !files.some((file) => file.file.type.includes('png')) &&
    !files.some((file) => file.file.type.includes('tif')) &&
    !files.some((file) => file.file.type.includes('docx')) &&
    !files.some((file) => file.file.type.includes('doc')) &&
    !files.some((file) => file.file.type.includes('xlxs'))
  );
};

export const isUploadFieldInvalid = (files: FileInfo[], field: InputFormField) => {
  return (
    field.elements.required.value[0].codename === 'yes' &&
    !files.some((file) => file.fieldName === UPLOAD_FORM_FIELD_KEY + field.elements.name.value)
  );
};
export const checkFileSize = (files: FileInfo[]) => {
  return files.some((file) => file.file.size >= 2500000);
};
// export const checkFileName = (files: FileInfo[]) => {
//   return (
//     !files.some((file)=> fileRegex.test(file.file.name))

//   );
// };
export const validateUploadField = (files: FileInfo[], field: InputFormField) => () => {
  //2500000
  let error;
  if (isUploadFieldInvalid(files, field)) {
    error = `${field.elements.name.value} is required.Please upload only pdf/docx/doc/txt/jpg/jpeg/tif/rtf/png files`;
  }
  if (isFileInValid(files)) {
    error = `Please upload only pdf/docx/doc/txt/jpg/jpeg/tif/rtf/png/xlxs files`;
  }
  if (checkFileSize(files)) {
    error = 'File size should not exceed 20MB';
  }
  // if(checkFileName(files)){
  //   error = 'File name should not contain special characters'
  // }
  return error;
};

export const getLabelName = (field: InputFormField | RadioFormField | DropdownFormField) => {
  return field.elements.label.value.concat(field.elements.required.value[0].codename === 'yes' ? '*' : '');
};
